import { render } from 'inferno'

export const infernoRemoveRootNode = container => {
  return () => {
    render(null, container)
  }
}
